<div class="flex flex-col gap-6">
  <div class="ec-category-header">
    {{ 'dashboard.overview.electricalheating.title' | translate }}
  </div>

  <div class="grid grid-cols-2 gap-4">
    <app-status-card [config]="electricalHeatingCreate"></app-status-card>
    <app-status-card [config]="electricalHeatingRemove"></app-status-card>
  </div>
</div>
